module.exports = __webpack_public_path__ + "img/methodes_arrow_uac.840b1d1f.png";